import { styled, Theme, Typography } from '@material-ui/core';

export const AccordionItemContent = styled('div')<
  Theme,
  { type: 'subchapter' | 'trajectory' | 'child-trajectory' }
>(({ type, theme }) => ({
  padding: '16px',
  paddingLeft: type === 'child-trajectory' ? '56px' : '',
  borderBottom: '1px solid #F3F1EC',
  display: 'flex',
  flexDirection: 'column',
  cursor: type === 'trajectory' || type === 'child-trajectory' ? 'pointer' : 'default',
  gap: 8,
  '&:hover': {
    color: theme.palette.trajectory.draft,
  },
}));

export const AccordionSummaryContent = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
}));

export const StyledTypography = styled(Typography)<
  Theme,
  {
    sample: null | 'isSample';
    type: 'subchapter' | 'trajectory' | 'child-trajectory';
    sampleColor: string | undefined;
    draft: boolean;
  }
>(({ theme, sample, type, sampleColor, draft }) => ({
  fontWeight: sample === 'isSample' || type === 'subchapter' ? 700 : 'inherit',
  lineHeight: '20px',

  color:
    sample === 'isSample' && sampleColor
      ? sampleColor
      : draft
      ? theme.palette.trajectory.draft
      : 'inherit',
}));
